import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Tabs,
  TabsList,
  TabsTrigger,
} from "../../../../../../shared/components/tabs/Tabs";
import { Badge } from "../../../../../../shared/components/badge/Badge";
import DatasetTabContent from "./DatasetTabContent";
import DimensionsTabContent from "./DimensionsTabContent";
import MetricsTabContent from "./MetricsTabContent";

const DatasetDetailPage = () => {
  const { t } = useTranslation();
  const [dimensionsLength, setDimensionsLength] = useState(0);
  const [metricsLength, setMetricsLength] = useState(0);
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <div className="w-full transition-colors p-4">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold">
            {t("datasetsCentre.datasets.detailTitle")}
          </h1>
          <p className="text-muted-foreground">
            {t("datasetsCentre.datasets.detailDescription")}
          </p>
        </div>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="space-y-6"
      >
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="overview">
            {t("datasetsCentre.common.overview")}
          </TabsTrigger>
          <TabsTrigger value="dimensions">
            {t("datasetsCentre.common.dimensions")}
            <Badge variant="secondary" className="ml-2">
              {dimensionsLength}
            </Badge>
          </TabsTrigger>
          <TabsTrigger value="metrics">
            {t("datasetsCentre.common.metrics")}
            <Badge variant="secondary" className="ml-2">
              {metricsLength}
            </Badge>
          </TabsTrigger>
        </TabsList>

        <DatasetTabContent />

        <DimensionsTabContent setDimensionsLength={setDimensionsLength} />

        <MetricsTabContent setMetricsLength={setMetricsLength} />
      </Tabs>
    </div>
  );
};

export default DatasetDetailPage;
